import asyncList from "./asyncList.component";

const asyncListModule = angular
  .module("app.components.asyncList", [])
  .component("asyncList", asyncList);

export default asyncListModule;



// WEBPACK FOOTER //
// ./src/components/asyncList/asyncList.module.js